////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
import convertHexToRGBA from '../../../helpers/HexToRgba'

//////STYLED//////
const TelecollectManagerStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => convertHexToRGBA(props.colorCode, 0.2)};
	color: ${(props) => props.colorCode};
	line-height: 32px;
	font-weight: bold;
	width: fit-content;
	padding: 0 10px;
	border-radius: 15px;
	margin: 0 auto;
`
//////STYLED//////

const TelecollectManagerStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TelecollectManagerStatusWrapper colorCode={props.row.paymentCollectionStatus.colorCode}>
			{translations[props.row.paymentCollectionStatus.translationKey]}
		</TelecollectManagerStatusWrapper>
	)
}

TelecollectManagerStatus.propTypes = {}

TelecollectManagerStatus.defaultPropTypes = {}

export default TelecollectManagerStatus
